import base from "../base";
import resortBase from "../base/resort";
import { BrandInterface } from "../interface";
import backgroundImage from "./background.jpg";
import favicon16 from "./favicon-16x16.png";
import favicon32 from "./favicon-32x32.png";
import favicon96 from "./favicon-96x96.png";
import logo from "./logo.svg";

const aBasin = {
  ...base,
  ...resortBase,
  title: "Arapahoe Basin",
  logo,
  backgroundImage,
  resortURL: "https://www.arapahoebasin.com/",
  favicons: {
    "16x16": favicon16,
    "32x32": favicon32,
    "96x96": favicon96,
  },
  color: {
    ...base.color,
    ...resortBase.color,
    header: "#03152A",
    footer: "#03152A",
    footerText: "#FFFFFF",
    button: "#012F64",
    buttonHover: "#03152A",
  },
} as BrandInterface;

export default aBasin;
